import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import LoginCard from "@mobilemind/common/src/components/LoginCard"
import { consumeAuthMessage } from "@mobilemind/common/src/functions/authMessage"
import { Box, Typography } from "@mui/material"
import { useAuth } from "../hooks/useAuth"
import "../styles/login.scss"

const API_URL = import.meta.env.VITE_API_URL || ""

interface LocationState {
  from?: string
}

function LoginPage() {
  const { isAuthenticated, isLoading, maintenanceMode } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [authMessage] = useState(consumeAuthMessage)

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      const from = (location.state as LocationState)?.from || "/"
      navigate(from, { replace: true })
    }
  }, [isAuthenticated, isLoading, navigate, location])

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          bgcolor: "background.default",
        }}
      >
        <Typography>Loading...</Typography>
      </Box>
    )
  }

  return (
    <Box className="page login">
      <LoginCard
        apiUrl={API_URL}
        authMessage={authMessage}
        title="Data Portal"
        description="Sign in to access reports and analytics"
        maintenanceMode={maintenanceMode}
        footer={
          <Typography variant="caption" color="textSecondary">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </Typography>
        }
      />
    </Box>
  )
}

export default LoginPage
